import { render } from "./StepWizard5.vue?vue&type=template&id=4a036b86"
import script from "./StepWizard5.vue?vue&type=script&lang=js"
export * from "./StepWizard5.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__